import { createContext } from 'react'

import { UserTypeContextEnum } from './UserTypeContextEnum'

export interface IUserTypeContext {
  userType: UserTypeContextEnum
  isAdmin: boolean
}

export const UserTypeContext = createContext({
  userType: UserTypeContextEnum.USER,
  isAdmin: false,
})
